import React from 'react';
import PropTypes from 'prop-types';

import calendarIcon from './images/calendar_integration.svg';
import emailIcon from './images/buildout_email_integration.svg';
import clickToCallIcon from './images/click_to_call.svg';

import CalendarModal from './integration_modals/calendar_modal';

import IntegrationsApi from './integrations_api';
import CancelCalendarModal from './integration_modals/cancel_calendar_modal';
import CancelTwilioModal from './integration_modals/cancel_twilio_modal';
import ActiveIntegrationsCard from './active_integrations_card';

export default class ActiveIntegrations extends React.Component {
  static propTypes = {
    clickToCallIntegration: PropTypes.shape({
      id: PropTypes.number,
      phoneNumber: PropTypes.string
    }),
    crmAccess: PropTypes.bool,
    currentDatabase: PropTypes.shape({
      forwardingEmail: PropTypes.string,
      name: PropTypes.string
    }).isRequired,
    currentUser: PropTypes.object,
    databases: PropTypes.array.isRequired,
    googleIntegration: PropTypes.shape({
      databaseId: PropTypes.number
    }),
    svnMember: PropTypes.bool
  };

  state = {
    showCancelCalendarModal: false,
    showCancelTwilioModal: false,
    showEditCalendarModal: false
  };

  api = new IntegrationsApi();

  handleShowCancelCalendarModal = () => this.setState({ showCancelCalendarModal: true });
  handleShowCancelTwilioModal = () => this.setState({ showCancelTwilioModal: true });
  handleShowEditCalendarModal = () => this.setState({ showEditCalendarModal: true });

  handleCloseModals = () => {
    this.setState({
      showCancelCalendarModal: false,
      showCancelTwilioModal: false,
      showEditCalendarModal: false
    });
  };

  handleUpdateGoogleIntegration = (databaseId) => {
    this.handleCloseModals();
    return this.api.updateGoogleIntegration(databaseId, this.props.currentUser.id).then(() => {
      window.location.reload();
    });
  };

  handleCancelGoogleIntegration = () => {
    return this.api.cancelGoogleIntegration(this.props.currentUser.id).then(() => {
      this.handleCloseModals();
      window.location.reload();
    });
  };

  handleCancelTwilioIntegration = () => {
    const { clickToCallIntegration, currentUser } = this.props;
    return this.api.cancelTwilioIntegration(clickToCallIntegration.id, currentUser.id).then(() => {
      this.handleCloseModals();
      window.location.reload();
    });
  };

  render() {
    return (
      <React.Fragment>
        {this.renderActiveIntegrations()}
        {this.renderEditCalendarModal()}
        {this.renderCancelCalendarModal()}
        {this.renderCancelTwilioModal()}
      </React.Fragment>
    );
  }

  renderCalendarBlock() {
    const { currentDatabase, databases, googleIntegration } = this.props;

    if (!googleIntegration || !googleIntegration.id) return;

    const connectedGoogleDatabase = databases.find(t => t.id === googleIntegration.databaseId);
    const isCurrentGoogleDatabase = connectedGoogleDatabase && googleIntegration.databaseId === currentDatabase.id;

    if (!isCurrentGoogleDatabase) return;

    return (
      <ActiveIntegrationsCard
        image={calendarIcon}
        name="calendar"
        onCancel={this.handleShowCancelCalendarModal}
        onEdit={this.handleShowEditCalendarModal}
      >
        <div className="d-flex flex-column gap-1">
          <p className="mt-2 mb-0 fw-semibold">Calendar Sync</p>
          <div className="fs-large text-muted">
            <span>Currently syncing calendar events from your Google Calendar</span>
          </div>
        </div>
      </ActiveIntegrationsCard>
    );
  }

  renderClickToCallBlock() {
    const { clickToCallIntegration } = this.props;

    if (clickToCallIntegration == null) return;

    return (
      <ActiveIntegrationsCard image={clickToCallIcon} name="click-to-call" onCancel={this.handleShowCancelTwilioModal}>
        <div className="d-flex flex-column gap-1">
          <p className="mt-2 mb-0 fw-semibold">Click-to-Call</p>
          <div className="fs-large text-muted">
            Currently connected to <strong>"{clickToCallIntegration.phoneNumber}"</strong>
          </div>
        </div>
      </ActiveIntegrationsCard>
    );
  }

  renderHelpCenterLink() {
    const { crmAccess, svnMember } = this.props;
    if (!crmAccess || !svnMember) return null;

    return (
      <a
        className="text-decoration-underline"
        name="help-center-link"
        rel="noopener noreferrer"
        target="_blank"
      >
        How to log an email automatically from your email client
      </a>
    );
  }

  renderEmailBlock() {
    const { currentDatabase } = this.props;
    return (
      <ActiveIntegrationsCard image={emailIcon} name="email">
        <div className="d-flex flex-column">
          <p className="mt-2 mb-0 fw-semibold">Buildout Database Email Forwarding</p>
          { this.renderHelpCenterLink() }
          <div className="pt-3">"{currentDatabase.name}" Forwarding Email: </div>
          <div className="fs-large">{currentDatabase.forwardingEmail}</div>
        </div>
      </ActiveIntegrationsCard>
    );
  }

  renderEditCalendarModal() {
    const { showEditCalendarModal } = this.state;
    const { currentDatabase, databases } = this.props;

    return (
      <CalendarModal
        currentDatabase={currentDatabase}
        databases={databases}
        shown={showEditCalendarModal}
        onCancel={this.handleCloseModals}
        onSave={this.handleUpdateGoogleIntegration}
      />
    );
  }

  renderCancelCalendarModal() {
    const { showCancelCalendarModal } = this.state;

    return (
      <CancelCalendarModal
        shown={showCancelCalendarModal}
        onCancel={this.handleCloseModals}
        onSave={this.handleCancelGoogleIntegration}
      />
    );
  }

  renderCancelTwilioModal() {
    const { showCancelTwilioModal } = this.state;

    return (
      <CancelTwilioModal
        shown={showCancelTwilioModal}
        onCancel={this.handleCloseModals}
        onSave={this.handleCancelTwilioIntegration}
      />
    );
  }

  renderActiveIntegrations() {
    return (
      <React.Fragment>
        <p className="fs-large fw-semibold mt-6 mb-0">Active Integrations</p>
        {this.renderEmailBlock()}
        {this.renderCalendarBlock()}
        {this.renderClickToCallBlock()}
      </React.Fragment>
    );
  }
}
